import FormInput from "@standard/components/FormInput/FormInput";
import TableForm from "@standard/components/TableForm";

const JobFormDocumentTemplateTable = ({
  values,
  onChange,
  onFileChange,
  disabled,
}) => {
  const fields = [
    {
      name: "name",
      label: "Name",
      type: disabled ? "label" : "textbox",
      required: true,
    },
    {
      name: "exampleAssets",
      label: "Example",
      type: "custom",
      control: (item, itemIndex) => {
        return (
          <div>
            {item.values.exampleFiles &&
              item.values.exampleFiles.length > 0 && (
                <div className="mt-3">
                  <FormInput
                    field={{
                      name: "exampleFiles",
                      type: "filePreview",
                      disabled: disabled,
                    }}
                    value={item.values.exampleFiles}
                    onChange={(d) => {
                      onFileChange(itemIndex, d);
                    }}
                  ></FormInput>
                </div>
              )}
            <FormInput
              field={{
                name: "exampleAssets",
                type: "file",
                multiple: true,
                disabled: disabled,
              }}
              onChange={(d) => {
                onFileChange(itemIndex, d);
              }}
            ></FormInput>
          </div>
        );
      },
    },
  ];

  return (
    <div className="col-12">
      <TableForm
        label="Documents"
        fields={fields}
        values={values}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default JobFormDocumentTemplateTable;
